import Joi from "joi";
import FormValidationResult from "../../../../../common/utils/validation/types/form-validation-result";
import formValidationService from "../../../../../common/utils/validation/form-validation.service";

const validateStreet = (street: string): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(50).required();

  return formValidationService.validate(street, validationSchema);
};

const validateHouseNumber = (houseNumber: string): FormValidationResult => {
  const validationSchema = Joi.string().max(10).trim().required();

  return formValidationService.validate(houseNumber, validationSchema);
};

const validateApartmentNumber = (
  apartmentNumber: string
): FormValidationResult => {
  const validationSchema = Joi.string().allow("").max(10).trim();

  return formValidationService.validate(apartmentNumber, validationSchema);
};

const validateTown = (town: string): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(50).trim().required();

  return formValidationService.validate(town, validationSchema);
};

const validateZipCode = (zipCode: string): FormValidationResult => {
  const validationSchema = Joi.string().min(2).max(10).trim().required();

  return formValidationService.validate(zipCode, validationSchema);
};

const validateDescription = (
  description: string | null
): FormValidationResult => {
  const validationSchema = Joi.string().min(0).max(100).trim();

  return formValidationService.validate(description, validationSchema);
};

const routesWaypointAddressAddFormValidationService = {
  validateStreet,
  validateHouseNumber,
  validateApartmentNumber,
  validateTown,
  validateZipCode,
  validateDescription,
};

export default routesWaypointAddressAddFormValidationService;
